module.exports = __webpack_public_path__ + "static/media/AllCards.580de8b6.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/tickets/AllCards.png
 ** module id = 467
 ** module chunks = 0
 **/